<style lang="scss" scoped>
div {
  display: inline-block;
  color: #68378d;
  font-size: 64px;
}
span {
  display: inline-block;
}
.space {
  width: 0.3em;
}
</style>

<template>
  <div>
    <span
      v-for="(c, i) in splitText"
      :key="c + i"
      :class="c == ' ' ? 'space' : ''"
      :style="
        `transform: translateY(${peak * Math.sin((i + shift) / period)}px)`
      "
      >{{ c }}</span
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      splitText: ""
    };
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    peak: {
      type: Number,
      default: 12
    },
    period: {
      type: Number,
      default: 1
    },
    shift: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.split();
  },
  methods: {
    split() {
      this.splitText = this.text.split("");
    }
  }
};
</script>
